var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounList1735098(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 847 847",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M423 21c223,0 403,180 403,402 0,223 -180,403 -403,403 -222,0 -402,-180 -402,-403 0,-222 180,-402 402,-402zm-239 524l479 0c13,0 25,12 25,25l0 0c0,14 -12,25 -25,25l-479 0c-14,0 -25,-11 -25,-25l0 0c0,-13 11,-25 25,-25zm0 -146l479 0c13,0 25,11 25,24l0 0c0,14 -12,25 -25,25l-479 0c-14,0 -25,-11 -25,-25l0 0c0,-13 11,-24 25,-24zm0 -147l479 0c13,0 25,11 25,24l0 0c0,14 -12,25 -25,25l-479 0c-14,0 -25,-11 -25,-25l0 0c0,-13 11,-24 25,-24z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounList1735098);
export default __webpack_public_path__ + "static/media/noun_List_1735098.13e0a16a.svg";
export { ForwardRef as ReactComponent };